<template>
    <q-drawer
        v-model="drawerOpen"
        side="right"
        bordered
        overlay
        behavior="mobile"
        :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'"
    >
        <q-scroll-area class="fit">
            <q-list>
                <q-item class="justify-end desktop-hide">
                    <q-btn
                        flat
                        round
                        dense
                        icon="close"
                        @click="drawerOpen = false"
                    />
                </q-item>

                <template v-if="navData.auth">
                    <!-- Me Menu -->
                    <q-item-label header>{{ navData.me.label }}</q-item-label>
                    <q-item
                        v-for="(item, index) in navData.me.items"
                        :key="'me-' + index"
                        clickable
                        v-ripple
                        :href="item.url"
                    >
                        <q-item-section avatar v-if="item.icon">
                            <q-icon :name="item.icon" />
                        </q-item-section>
                        <q-item-section>
                            {{ item.label }}
                        </q-item-section>
                        <q-item-section side v-if="item.rightIcon">
                            <q-icon
                                :name="item.rightIcon"
                                :color="item.rightColor"
                            />
                        </q-item-section>
                    </q-item>

                    <!-- Switch Calendar -->
                    <template v-if="navData.me.switchCalendar">
                        <q-separator />
                        <q-item-label header>{{
                            navData.me.switchCalendar.label
                        }}</q-item-label>
                        <q-item
                            v-for="(cal, idx) in navData.me.switchCalendar.list"
                            :key="'cal-' + idx"
                            clickable
                            v-ripple
                            :href="cal.url"
                        >
                            <q-item-section>
                                {{ cal.name }}
                            </q-item-section>
                            <q-item-section side v-if="cal.active">
                                <q-icon name="check_circle" color="primary" />
                            </q-item-section>
                        </q-item>
                        <q-item
                            clickable
                            v-ripple
                            :href="navData.me.switchCalendar.editUrl"
                        >
                            <q-item-section>{{
                                navData.me.switchCalendar.editLabel
                            }}</q-item-section>
                        </q-item>
                    </template>

                    <q-separator />

                    <!-- Top Calendar Switch (if enabled) -->
                    <template
                        v-if="
                            navData.calendars && navData.calendars.showTopSwitch
                        "
                    >
                        <q-item-label header>{{
                            navData.calendars.label || "Calendars"
                        }}</q-item-label>
                        <q-item
                            v-for="(cal, idx) in navData.calendars.list"
                            :key="'top-cal-' + idx"
                            clickable
                            v-ripple
                            :href="cal.url"
                        >
                            <q-item-section>
                                {{ cal.name }}
                            </q-item-section>
                            <q-item-section side v-if="cal.active">
                                <q-icon name="check_circle" color="primary" />
                            </q-item-section>
                        </q-item>
                        <q-separator />
                    </template>

                    <!-- Calendar Link -->
                    <!-- <template v-if="navData.calendarLink && navData.calendarLink.show">
                        <q-item
                            v-if="!navData.calendarLink.extended"
                            clickable
                            v-ripple
                            :href="navData.calendarLink.url"
                        >
                            <q-item-section>{{ navData.calendarLink.label }}</q-item-section>
                        </q-item>
                        <template v-else>
                            <q-item-label header>{{ navData.calendarLink.label }}</q-item-label>
                            <q-item
                                v-for="(link, idx) in navData.calendarLink.items"
                                :key="'cal-link-' + idx"
                                clickable
                                v-ripple
                                :href="link.url"
                            >
                                <q-item-section>{{ link.label }}</q-item-section>
                            </q-item>
                        </template>
                    </template>-->

                    <!-- Campaigns -->
                    <template v-if="navData.campaigns">
                        <q-item
                            v-if="navData.campaigns.showMixed"
                            clickable
                            v-ripple
                            :href="navData.campaigns.mixedUrl"
                        >
                            <q-item-section>{{
                                navData.campaigns.mixedLabel
                            }}</q-item-section>
                        </q-item>
                        <q-item
                            v-if="navData.campaigns.top"
                            clickable
                            v-ripple
                            :href="navData.campaigns.top.url"
                        >
                            <q-item-section avatar
                                ><q-icon name="campaign"
                            /></q-item-section>
                            <q-item-section>{{
                                navData.campaigns.top.label
                            }}</q-item-section>
                        </q-item>
                        <q-separator
                            v-if="
                                navData.campaigns.showMixed ||
                                navData.campaigns.top
                            "
                        />
                    </template>

                    <!-- Other / Instructions -->
                    <template v-if="navData.other && navData.other.show">
                        <q-item-label header>{{
                            navData.other.label
                        }}</q-item-label>
                        <q-item
                            v-for="(item, idx) in navData.other.items"
                            :key="'other-' + idx"
                            clickable
                            v-ripple
                            :href="item.url"
                        >
                            <q-item-section>{{ item.label }}</q-item-section>
                        </q-item>
                        <q-separator />
                    </template>

                    <!-- Admin -->
                    <template v-if="navData.admin">
                        <q-item-label header>{{
                            navData.admin.label
                        }}</q-item-label>
                        <q-item
                            v-for="(item, idx) in navData.admin.items"
                            :key="'admin-' + idx"
                            clickable
                            v-ripple
                            :href="item.url"
                        >
                            <q-item-section
                                :class="item.isAdmin ? 'text-negative' : ''"
                            >
                                {{ item.label }}
                            </q-item-section>
                        </q-item>
                        <q-separator />
                    </template>

                    <!-- Dev -->
                    <template
                        v-if="
                            navData.dev &&
                            navData.dev.items &&
                            navData.dev.items.length > 0
                        "
                    >
                        <q-item-label
                            header
                            class="bg-deep-orange-6 text-white"
                            >{{ navData.dev.label }}</q-item-label
                        >
                        <q-item
                            v-for="(item, idx) in navData.dev.items"
                            :key="'dev-' + idx"
                            clickable
                            v-ripple
                            :href="item.url"
                        >
                            <q-item-section>
                                {{ item.label }}
                            </q-item-section>
                        </q-item>
                        <q-separator />
                    </template>
                </template>

                <template v-else>
                    <!-- Guest view: toolbar will provide language selector -->
                </template>
            </q-list>
        </q-scroll-area>
        <div
            class="q-mini-drawer-hide absolute"
            style="top: 15px; right: -17px"
        >
            <q-btn
                dense
                round
                unelevated
                color="accent"
                icon="chevron_right"
                @click="drawerOpen = false"
            />
        </div>
    </q-drawer>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
    name: "NavigationDrawer",
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        navData: {
            type: Object,
            required: true,
        },
    },
    emits: ["update:modelValue"],
    setup(props, { emit }) {
        const drawerOpen = computed({
            get: () => props.modelValue,
            set: (val) => emit("update:modelValue", val),
        });

        return {
            drawerOpen,
        };
    },
});
</script>
<style lang="scss">
div.q-item__label--header {
    font-weight: bold;
    background-color: grey;
    color: white;
}
</style>
